// removed by extract-text-webpack-plugin
module.exports = {"checkbox":"checkbox__checkbox__3IXuh"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Form/Checkbox/checkbox.css
// module id = 879
// module chunks = 2